import styled from "styled-components";
import { Form } from "@themesberg/react-bootstrap";


const ThumbnailModalContent = styled.div`
  padding: 1rem 0;
`;

const ThumbnailPreview = styled.div`
  margin-top: 1rem;
  text-align: center;
  
  img {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
  
  .placeholder {
    width: 100%;
    height: 150px;
    background-color: #f5f5f5;
    border: 1px dashed #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #888;
    border-radius: 4px;
  }
`;

const StyledSelect = styled(Form.Select)`
  option:first-child {
    display: none;
  }
`;

export { ThumbnailModalContent, ThumbnailPreview , StyledSelect}